/** @file settingNumberValue: reads the text of a settings number field (ignore, or the clamped value). */

/** `ignore`: nothing to write (empty or not a number); `set`: the value to store and whether it was clamped or rounded. */
export type SettingNumberResult = { kind: 'ignore' } | { kind: 'set'; value: number; changed: boolean };

/** What bounds apply: `integer` rounds to a whole number first. */
export type SettingNumberRange = { min?: number; max?: number; integer?: boolean };

/** An empty field is ignored (never 0); anything else is rounded when `integer`, then clamped into `min`..`max`. */
export function settingNumberValue(text: string, { min, max, integer = false }: SettingNumberRange = {}): SettingNumberResult {
  if (text.trim() === '') return { kind: 'ignore' };
  const typed = Number(text);
  if (!Number.isFinite(typed)) return { kind: 'ignore' };
  const rounded = integer ? Math.round(typed) : typed;
  const value = Math.min(max ?? Number.POSITIVE_INFINITY, Math.max(min ?? Number.NEGATIVE_INFINITY, rounded));
  return { kind: 'set', value, changed: value !== typed };
}
